import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label } from "reactstrap";
import axios from "axios";
import { API_URL_subproyectos } from "../../constants";
import { getAuthHeaders } from "../../utils/auth";
import { IconPlus, IconPencil } from "../ui/icons";

const NewSubproyectoModal = ({ create, proyectoCode, subproyecto, resetState, subproyectoDate }) => {
  const [startDate, setStartDate] = useState("");

  useEffect(() => {
    // Set startDate to subproyecto's start_date if editing
    if (!create && subproyecto) {
      setStartDate(subproyectoDate|| ""); // Default to empty string if start_date is undefined
    }
  }, [create, subproyecto]);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleSave = async () => {
    try {
      const payload = {
        proyecto_code: proyectoCode,
        start_date: startDate,
      };

      const headers = getAuthHeaders();

      if (create) {
        // Create a new subproyecto
        const response = await axios.post(API_URL_subproyectos, payload, { headers });
      } else {
        // Update an existing subproyecto
        const response = await axios.put(
          `${API_URL_subproyectos}${subproyecto}/`,
          payload,
          { headers }
        );
        console.log("Subproyecto updated:", response.data);
      }

      resetState(); // Refresh the parent component
      toggle(); // Close the modal
    } catch (error) {
      console.error("Error saving subproyecto:", error.response?.data || error.message);
    }
  };

  return (
    <>
      <Button
        color="secondary"
        onClick={toggle}
        size="sm"
        data-lssi-action-icon
        aria-label={create ? "Crear Subproyecto" : "Editar Subproyecto"}
        title={create ? "Crear Subproyecto" : "Editar Subproyecto"}
      >
        {create ? <IconPlus /> : <IconPencil />}
        <span className="lssi-action-label">
          {" "}{create ? "Crear Sub" : "Editar Subproyecto"}
        </span>
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {create ? "Crear Sub" : "Editar Subproyecto"}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="startDate">Fecha de Inicio</Label>
            <Input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default NewSubproyectoModal;